<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mt-5">
      <div>
        <div class="row">
          <div class="col-lg-9 col-sm-8">
            <div class="p-4">
              <div>
                <h5 class="text-sub">
                  <v-icon size="25" :class="isRtl ? 'ml-2':'mr-2'"
                    >$vuetify.icons.coloredLogo</v-icon
                  >{{ $t("How it works ?") }}
                  
                </h5>
                <p class="text-muted">
                  {{$t('Integrations connect your software to our system so we can share information from yours. Sharing this data to our system will provide you with more features and options and make it easy for you to just focus on your business.')}}
                </p>
              </div>

              <div class="text-primary font-weight-bold">
                <p class="mb-1 d-flex">
                  <v-icon :class="isRtl ? 'ml-1':'mr-1'" size="12" color="secondary">
                    mdi-square-rounded
                  </v-icon>
                  {{ $t("Search for the integration you looking for.") }}
                </p>
                <p class="mb-1 d-flex">
                  <v-icon :class="isRtl ? 'ml-1':'mr-1'" size="12" color="secondary">
                    mdi-square-rounded
                  </v-icon>

                  {{$t('Click on the integration or the“')}} &nbsp;<v-icon
                    :class="isRtl ? 'ml-1':'mr-1'"
                    size="12"
                    color="secondary"
                  >
                    mdi-plus-thick</v-icon
                  >
                  {{$t('“ icon.')}}
                </p>
                <p class="mb-1 d-flex">
                  <v-icon :class="isRtl ? 'ml-1':'mr-1'" size="12" color="secondary">
                    mdi-square-rounded
                  </v-icon>

                  {{ $t("Enter your store’s URL") }}
                </p>
                <p class="mb-0 d-flex">
                  <v-icon :class="isRtl ? 'ml-1':'mr-1'" size="12" color="secondary">
                    mdi-square-rounded
                  </v-icon>
                  {{ $t("Kick off your journey with") }}
                  <strong class="fw-bolder"> &nbsp; WeStore</strong>
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-sm-4 align-self-center d-none d-md-block">
            <div>
              <img
                src="@/assets/images/crypto/features-img/img-1.png"
                alt
                class="img-fluid d-block"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="row mb-4 py-5" ref="carouselContainer">
        <v-row v-if="showContentLoader">
          <v-col v-for="n in 4" :key="n" md="4" sm="6" lg="4" xl="3" xs="12">
            <SkeletonLoader type="image" />
          </v-col>
        </v-row>

        <split-carousel
          v-else
          :loop="loop"
          :autoplay="autoplay"
          :speed="speed"
          :interval="interval"
          :item-width="itemWidth"
          :item-align="itemAlign"
          :hover-cancel-play="hoverCancelPlay"
          :display-amount="displayAmount"
          :arrow-visible="arrowVisible"
          :height="height"
          :timing-function="timingFuntion"
          :arrow-area-width="arrowAreaWidth"
          :play-direction="playDirection"
        >
          <split-carousel-item v-for="(market, i) in this.markets" :key="i">
            <marketplace-card :market="market" />
          </split-carousel-item>
        </split-carousel>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import MarketplaceCard from "../../../components/marketplace-card.vue";
import { MarketPlaces } from "../../../services/westore/entities";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";

export default {
  components: {
    Layout,
    PageHeader,
    MarketplaceCard,
    SkeletonLoader,
  },
  data() {
    return {
      title: "OUR INTEGRATIONS",
      subtitle: "",
      markets: [
        {
          id: "shopify",
          marketName: "Shopify",
          // status: "Coming Soon",
          logo: require("@/assets/images/integrations/marketplaces/shopify.png"),
        },
        {
          id: "amazon-ae",
          marketName: "Amazon UAE",
          //  status: "Coming Soon",
          logo: require("@/assets/images/integrations/marketplaces/amazon-ae.png"),
        },
        {
          id: "woocommerce",
          marketName: "Woocommerce",

          logo: require("@/assets/images/integrations/marketplaces/woocommerce.png"),
        },
        {
          id: "wix",
          marketName: "Wix",
          //  status: "Coming Soon",
          logo: require("@/assets/images/integrations/marketplaces/wix.png"),
        },
        {
          id: "salla",
          marketName: "salla",
          logo: require("@/assets/images/integrations/marketplaces/salla.webp"),
        },
        {
          id: "noon",
          marketName: "Noon",
          //  status: "Coming Soon",
          logo: require("@/assets/images/integrations/marketplaces/noon.jpg"),
        },
      ],
      successModal: false,
      message: "",
      icon: "",
      buttonColor: "",
      showContentLoader: true,
      autoplay: false,
      loop: true,
      speed: 2000,
      interval: 1800,
      //displayAmount: 3,
      displayAmount: this.$vuetify.breakpoint.mdAndUp
        ? 4
        : this.$vuetify.breakpoint.xsOnly
        ? 2
        : 3,
      itemWidth: 300,

      arrowVisible: "enable",
      itemAlign: "center",
      hoverCancelPlay: true,
      height: 200,
      arrowAreaWidth: 50,
      playDirection: "ltr",
      timingFuntion: "ease-in-out",
      timingFuntionOptions: [
        {
          value: "ease",
          label: "ease",
        },
        {
          value: "ease-in",
          label: "ease-in",
        },
        {
          value: "ease-out",
          label: "ease-out",
        },
        {
          value: "ease-in-out",
          label: "ease-in-out",
        },
        {
          value: "linear",
          label: "linear",
        },
        {
          value: "steps(2, start)",
          label: "steps(2, start)",
        },
        {
          value: "cubic-bezier(0.06, 0.29, 0.19, 1.4)",
          label: "cubic-bezier(0.06, 0.29, 0.19, 1.4)",
        },
      ],
    };
  },

  created() {
    if (Object.keys(this.$route.query).length === 0) return;

    if (
      this.$route.query.integrated === "true" ||
      this.$route.query.integrated === true
    ) {
      this.$toast.success("Your Integration has been setup successfully");
    } else {
      this.$toast.error("Something went wrong,please try again");
    }
  },
  mounted() {
    this.fetchData();
    this.itemWidth =
      this.$refs.carouselContainer.clientWidth / (this.displayAmount * 1.1);
  },
  methods: {
    async fetchData() {
      this.showContentLoader = true;
      let { data } = await MarketPlaces.getAll();

      this.markets = this.markets.map((market) => {
        let integratedMarket = data.find((el) => el.marketplace === market.id);
        if (integratedMarket && !market.status) {
          return {
            ...market,
            status: "Integrated",
            store_url: integratedMarket.store_url,
            id: integratedMarket.id,
          };
        } else if (!integratedMarket && !market.status) {
          return { ...market, status: "Not Integrated" };
        } else {
          return market;
        }
      });

      this.showContentLoader = false;
    },
    getWidth() {
      console.log(this.$refs.carouselContainer.clientWidth);
    },
  },
};
</script>
<style scoped></style>
